import { ComponentStyleConfig } from '@chakra-ui/react'

export const Card: ComponentStyleConfig = {
  baseStyle: {
    color: '#000000',
  },
}
